import { defineMessages } from 'react-intl';

export default {
  ...defineMessages({
    reasonSelectionTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.title',
      defaultMessage: 'Report ClassPass User',
    },
    reportDetailsTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.report-details-title',
      defaultMessage: 'Please provide additional details',
    },
    reportingLabel: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.reporting-label',
      defaultMessage: 'Reporting:',
    },
    disruptiveUser: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user',
      defaultMessage: 'Disruptive User',
    },
    disruptiveUserDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-description',
      defaultMessage: 'Users who are repetitively late, rude to staff, or not following studio policy.',
    },
    trialProgramAbuse: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.trial-program-abuse',
      defaultMessage: 'Trial Program Abuse',
    },
    trialProgramAbuseDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.trial-program-abuse-description',
      defaultMessage: 'Users who look to be getting around our trial eligibility.',
    },
    userAlreadyReported: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.user-already-reported',
      defaultMessage: 'User already reported',
    },
    select: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.select',
      defaultMessage: 'Select',
    },
    selectReason: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.select-reason',
      defaultMessage: 'Select from below the reason for reporting this user.',
    },
    footerText: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.footer-text',
      defaultMessage: 'For more info or further assistance, <a>learn more</a> or <contactUs>contact us</contactUs>.',
    },

    guidancePanelClosedStateLabel: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.guidance-panel-open-label',
      defaultMessage: 'Open to learn more about:',
    },
    guidancePanelOpenStateLabel: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.guidance-panel-close-label',
      defaultMessage: 'Close to hide content:',
    },
    guidancePanelReportingFor: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.guidance-panel-reporting-for',
      defaultMessage: 'You are reporting for:',
    },
    trialAbuseGuidelineEligibilityTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.trial-abuse-guideline-eligibility-title',
      defaultMessage: 'Trial Eligibility',
    },
    trialAbuseGuidelineEligibilityDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.trial-abuse-guideline-eligibility-description',
      defaultMessage:
        'Trial visits are available to new users on a trial, or to trial users who have not visited your studio in the past 12 months.',
    },
    trialAbuseGuidelineVisitTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.trial-abuse-guideline-visit-title',
      defaultMessage: 'One Visit Per Studio',
    },
    trialAbuseGuidelineVisitDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.trial-abuse-guideline-visit-description',
      defaultMessage:
        'Trial users are only eligible to book once at a studio during their trial period. If a user appears more than once they may have committed to a paid membership.',
    },
    trialAbuseGuidelineSharingTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.trial-abuse-guideline-sharing-title',
      defaultMessage: 'Account Sharing',
    },
    trialAbuseGuidelineSharingDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.trial-abuse-guideline-sharing-description',
      defaultMessage:
        "Trial accounts are strictly for individual use. Sharing credentials with multiple users is against ClassPass's policies.",
    },
    disruptiveUserGuidelineExamplesTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-examples-title',
      defaultMessage: 'Examples of disruptive behavior',
    },
    disruptiveUserGuidelineLateDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-late-description',
      defaultMessage: 'Repeatedly arriving late to class',
    },
    disruptiveUserGuidelinePolicyDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-policy-description',
      defaultMessage: 'Not following studio policies or staff instructions',
    },
    disruptiveUserGuidelineRudeDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-rude-description',
      defaultMessage: 'Rude or disrespectful behavior toward staff or other clients',
    },
    disruptiveUserGuidelineSeriousBehaviorNote: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-serious-behavior-note',
      defaultMessage: 'To report more serious behavior, contact our team directly using the link on this page.',
    },
    disruptiveUserGuidelineIncludeTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-include-title',
      defaultMessage: 'What to include in your report',
    },
    disruptiveUserGuidelineDateDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-date-description',
      defaultMessage: 'Date and time of incident',
    },
    disruptiveUserGuidelineFactDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-fact-description',
      defaultMessage: 'A brief, factual description of what happened (what was said/done)',
    },
    disruptiveUserGuidelineFrequencyDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-frequency-description',
      defaultMessage: 'Frequency (one-time vs. repeated) and any prior warnings given',
    },
    disruptiveUserGuidelineStepsTakenDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-steps-taken-description',
      defaultMessage: 'Any steps your team has already taken to resolve the issue',
    },
    disruptiveUserGuidelineAffectedDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-user-guideline-affected-description',
      defaultMessage: 'Whether and how staff or other clients were impacted',
    },
    learnMore: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.learn-more',
      defaultMessage: 'Learn more',
    },
    additionalDetailsLabel: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.additional-details-label',
      defaultMessage: 'Additional Details *',
    },
    additionalDetailsPlaceholder: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.additional-details-placeholder',
      defaultMessage: 'Please provide additional details',
    },
    selectReasonLabel: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.select-reason-label',
      defaultMessage: 'Select reason *',
    },
    disruptiveReasonRepeatedlyLate: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-reason-repeatedly-late',
      defaultMessage: 'Repeatedly arriving late',
    },
    disruptiveReasonNotFollowingPolicy: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-reason-not-following-policy',
      defaultMessage: 'Not following studio policy',
    },
    disruptiveReasonRudeToStaff: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.disruptive-reason-rude-to-staff',
      defaultMessage: 'Rude to staff',
    },
    seriousBehaviorGuidance: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.serious-behavior-guidance',
      defaultMessage: 'For more serious behavior please reach out to our team <here>here.</here>',
    },
    cancelButton: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.cancel-button',
      defaultMessage: 'Cancel',
    },
    submitButton: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.submit-button',
      defaultMessage: 'Submit Report',
    },
    guidancePanelTrialAbuseTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.guidance-panel-title',
      defaultMessage: 'Trial Program Eligibility & Usage',
    },
    guidancePanelDisruptiveUserTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.guidance-panel-disruptive-user-title',
      defaultMessage: 'Reporting Guidance',
    },
    guidancePanelTrialAbuseDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.guidance-panel-description',
      defaultMessage: 'Please review these guidelines before reporting suspected Trial program abuse.',
    },
    guidancePanelDisruptiveUserDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.guidance-panel-disruptive-user-description',
      defaultMessage: 'Please review these guidelines before reporting this user for disruptive behavior',
    },
    collapseGuidancePanelAriaLabel: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.collapse-guidance-panel-aria-label',
      defaultMessage: 'Collapse details',
    },
    expandGuidancePanelAriaLabel: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.expand-guidance-panel-aria-label',
      defaultMessage: 'Expand details',
    },
    feedbackDisclosure: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.feedback-disclosure',
      defaultMessage: 'Please be aware that feedback may be disclosed to users on request.',
    },
    processingReportTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.processing-report-title',
      defaultMessage: 'Processing your report',
    },
    processingReportDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.processing-report-description',
      defaultMessage: "We're completing a few quick checks.",
    },
    processingReportCallout: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.processing-report-callout',
      defaultMessage: 'This usually takes a few seconds',
    },
    successReportTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-report-title',
      defaultMessage: 'Report submitted successfully',
    },
    successReportDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-report-description',
      defaultMessage: 'Thank you, our team will investigate your report and take appropriate action.',
    },
    successPayoutBanner: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-payout-banner',
      defaultMessage: 'Payout applied. This reservation will be paid.',
    },
    successWhatHappensNext: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-what-happens-next',
      defaultMessage: 'What happens next?',
    },
    successGuidelinePayoutTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-guideline-payout-title',
      defaultMessage: 'Payout guaranteed!',
    },
    successGuidelinePayoutDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-guideline-payout-description',
      defaultMessage:
        'This reservation will be paid either because the reported user was on a paid plan or, for trial users, as a one-time goodwill payout regardless of the outcome of our review.',
    },
    successGuidelineInvestigationTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-guideline-investigation-title',
      defaultMessage: 'Investigation Process',
    },
    successGuidelineInvestigationDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-guideline-investigation-description',
      defaultMessage: 'Our compliance team will review the reported account.',
    },
    successGuidelineEnforcementTitle: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-guideline-enforcement-title',
      defaultMessage: 'Enforcement Action',
    },
    successGuidelineEnforcementDescription: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-guideline-enforcement-description',
      defaultMessage:
        'If violations are confirmed, appropriate measures will be taken including account suspension or termination as needed.',
    },
    successPayoutBannerUnpaid: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-payout-banner-unpaid',
      defaultMessage: "We'll review this within 24-48 business hours.",
    },
    successGuidelineProtectionTitleUnpaid: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-guideline-protection-title-unpaid',
      defaultMessage: 'Platform Protection',
    },
    successGuidelineProtectionDescriptionUnpaid: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.success-guideline-protection-description-unpaid',
      defaultMessage:
        'Your report helps us maintain fair access for all legitimate users and protects our studio partners.',
    },
    submitError: {
      id: 'reservation-feedback.reservation-feedback-modal-v2.submit-error',
      defaultMessage: 'Whoops something went wrong. Please try again or <contactUs>contact us</contactUs>.',
    },
  }),
};
